"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./ExitableInput.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ExitableInput = function ExitableInput(props) {
  var pre = props.pre,
      value = props.value,
      _onChange = props.onChange;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "posr"
  }, pre, /*#__PURE__*/_react["default"].createElement("input", {
    style: {
      textIndent: '20px'
    },
    className: "clearable",
    type: "search",
    value: value,
    onChange: function onChange(e) {
      return _onChange(e);
    }
  }));
};

ExitableInput.defaultProps = {
  pre: null
};
ExitableInput.propTypes = {
  pre: _propTypes["default"].element,
  value: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func.isRequired
};
var _default = ExitableInput;
exports["default"] = _default;